import { classNames } from "../../../../../lib/classNames"

interface RadioButtonProps {
  checked: boolean
  className?: string
  label?: string
  disabled?: boolean
  error?: boolean
}

export function RadioButton({
  checked,
  className,
  disabled,
  error,
  label,
}: RadioButtonProps) {
  return (
    <div
      className={classNames(
        "group flex flex-row items-center gap-x-2",
        className
      )}
      data-checked={checked || undefined}
      data-disabled={disabled || undefined}
      data-error={error || undefined}
    >
      <div
        className={classNames(
          "border-icon-subtlest group-hover:not-group-data-disabled:border-icon-subtle flex size-4 items-center justify-center rounded-full border-[1.5px]",
          "group-data-checked:border-5 group-data-checked:border-bg-primary-default group-data-checked:group-hover:border-bg-primary-hovered group-data-checked:group-data-disabled:border-bg-primary-disabled",
          "group-data-error:border-2 group-data-error:border-v2-border-danger group-data-error:group-hover:border-v2-border-danger"
        )}
      />
      {label && (
        <div className="text-body color-default group-data-disabled:color-disabled grow select-none">
          {label}
        </div>
      )}
    </div>
  )
}
